import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet';

import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';

import Plate from 'components/UI/Plate/Plate';
import Button from 'components/UI/Button/Button';
import { TextInput } from 'components/UI/TextInput/TextInput';

import { getCookie, setCookie } from 'utils/cookie.js';

import AppStore from 'AppStore.js';
import popupStore from 'components/Popup/PopupStore.js';
import messageBoxStore from 'MessageBox/MessageBoxStore';

import client, { ApiError } from 'client';

import {
  SMART_CAPTCHA_KEY,
  SMART_CAPTCHA_TEST,
} from 'smart-captcha.js';

import './SignIn.scss';

export const SignIn = observer(() => {

  const navigate = useNavigate();
  const redirectUrl = getCookie('redirect_url');

  const [isBusy, setIsBusy] = useState(false);

  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const [captchaKey, setCaptchaKey] = useState(0);
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaVisible, setCaptchaVisible] = useState(false);

  async function onSubmit() {
    if (isBusy || captchaVisible)
      return;

    if (!login)
      return messageBoxStore.showError('Введите email');
    if (!password)
      return messageBoxStore.showError('Введите пароль');

    if (SMART_CAPTCHA_KEY)
      return setCaptchaVisible(true);
    onCaptchaSuccess(captchaToken);    
  }

  async function onCaptchaSuccess(captchaToken) {
    setCaptchaVisible(false);
    setCaptchaToken(captchaToken);

    let token = '';

    setIsBusy(true);
    try {
      token = await client.signin({ login, password, captcha: captchaToken });
      AppStore.setToken(token);
      await AppStore.updateProfile();
      if (!AppStore.profile?.agree) {
        popupStore.open('accept-rules');
      }
    } catch (e) {
      setCaptchaKey(captchaKey + 1);
      if (e instanceof ApiError) {
        messageBoxStore.showError(e.message);
        return;
      }
      throw e;
    } finally {
      setIsBusy(false);
    }

    AppStore.setToken(token);

    setCookie('redirect_url', '', { expires: -1 });
    if (redirectUrl && redirectUrl !== '/') {
      navigate(redirectUrl);
    } else {
      navigate('/projects');
    }
  }

  return (
    <div className='signin_page'>
      <Helmet>
        <title>Вход в сервис по накрутке — Boostclick</title>
        <meta name="description" content="Вход в сервис по накрутке ПФ и взаимодействий — Boostclick" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href={window.location.origin + window.location.pathname} />
      </Helmet>

      <div className='signin'>
        <form className="signin__form" onSubmit={e => { e.preventDefault(); onSubmit() }}>
          <Plate className='signin__plate'>
            <h1 className='signin__title'>Вход</h1>

            <TextInput classes={["signin__input"]} placeholder='Email' type='email' onChange={e => setLogin(e.target.value)} />
            <TextInput classes={["signin__input"]} placeholder='Пароль' type='password' onChange={e => setPassword(e.target.value)} />

            <Button title='Войти в мой аккаунт' />

            <div className='signin__links-container'>
              <Link className='signin__link' to='/signup'>Регистрация</Link>
              <Link className='signin__link' to='/restore'>Забыли пароль?</Link>
            </div>
          </Plate>
        </form>
      </div>

      {SMART_CAPTCHA_KEY && <InvisibleSmartCaptcha
        key={captchaKey}
        sitekey={SMART_CAPTCHA_KEY}
        test={SMART_CAPTCHA_TEST}
        visible={captchaVisible}
        hideShield={true}
        onSuccess={onCaptchaSuccess}
        onTokenExpired={() => setCaptchaToken('')}
        onNetworkError={() => setCaptchaVisible(false)}
        onChallengeHidden={() => setCaptchaVisible(false)}
      />}

    </div>
  );
});
